import styled from "styled-components"

const Base = styled.section`
  padding: 5rem 1rem;
`

export default Base
